class NavigationMenu {
  constructor(buttonEl, listEl) {
    this.buttonEl = buttonEl;
    this.listEl = listEl;
  }

  init() {
    this.buttonEl.addEventListener("mouseenter", () => {
      this.listEl.classList.add("open");
    });
    this.buttonEl.addEventListener("mouseleave", () => {
      this.listEl.classList.remove("open");
    });
  }
}

window.NavigationMenu = NavigationMenu;
